import { connect } from 'react-redux'
import {
  createNewLocation,
  resetCreateLocationStatusMessages,
  setAvailableLocations,
  setLocation,
  types,
  loadElements,
} from '../../../../actions/projects/form_actions'
import { createLoadingSelector } from '../../../../libs/requests_status_handlers'

const loadingSelector = createLoadingSelector([types.CREATE_NEW_LOCATION])

export default connect(
  (state: any) => ({
    createLocationError: state.projects?.form?.createLocation?.error,
    createLocationSuccess: state.projects?.form?.createLocation?.success,
    availableLocations: state.projects?.form?.availableLocations || [],
    location: state.projects?.form?.location,
    isFetching: loadingSelector(state),
  }),
  {
    createNewLocation,
    resetCreateLocationStatusMessages,
    setAvailableLocations,
    setLocation,
    loadElements,
  }
)